import { render, staticRenderFns } from "./ResetCredentials.vue?vue&type=template&id=a3904e7c&"
import script from "./ResetCredentials.ts?vue&type=script&lang=ts&"
export * from "./ResetCredentials.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports